import React, { useState } from "react";
import "./Newsletter_offcanvas.css";
import { Offcanvas, Form } from "react-bootstrap";
import Dark_Gray_Btn from "../common_btn/dark_gray_btn/Dark_Gray_Btn";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useForm } from "react-hook-form";
import { Subscriber } from "../../../utils/apis/form/form";
import { RegxExpression } from "../../../utils/common";
import SuccessfullyModal from "../../../components/Common-Component/Commonmodal/SuccessfullyModal/SuccessfullyModal";

function Newsletter_offcanvas({ show, handleClose }) {
  const [email, setEmail] = useState("");
  const [isSubmitted, setIsSubmitted] = useState(false);

  // const handleSubmit = (e) => {
  //   e.preventDefault();

  //   if (!email.trim()) {
  //     setIsSubmitted(true);
  //     return;
  //   }

  //   alert("Subscribed Successfully ✅");
  //   setEmail("");
  //   setIsSubmitted(false);
  //   handleClose();
  // };

  const {
    control,
    register,
    handleSubmit,
    getValues,
    setError,
    clearErrors,
    formState: { errors },
    reset,
    trigger,
  } = useForm();
  const [showSuccess, setShowsuccess] = useState(false);
  const onSubmit = async (data) => {
    const res = await Subscriber(data);
    if (res?.success) {
      setShowsuccess(true);
      setTimeout(() => {
        reset();
        setShowsuccess(false);
      }, 2000);
    } else {
      if (res?.message?.email) {
        setError("email", { message: res?.message?.email });
      }
    }
  };
  return (
    <>
      <section className="Newsletter_offcanvas">
        <Offcanvas
          show={show}
          onHide={handleClose}
          placement="end"
          size="md"
          className="newsletter_canvas"
        >
          <Offcanvas.Body>
            {/* Header */}
            <div className="newsletter_header">
              <button className="close_btn" onClick={handleClose}>
                <FontAwesomeIcon icon={faXmark} />
              </button>

              <h2 className="newsletter_title">NEWSLETTER</h2>
            </div>

            {/* Form */}
            <div className="newsletter_form_area">
              <p className="required_info">* Required Information</p>

              <Form onSubmit={handleSubmit(onSubmit)}>
                <Form.Group className="mb-2">
                  <Form.Label className="email_label">Email Address*</Form.Label>

                  <Form.Control
                    type="text"
                    name="email"
                    aria-label="Recipient's username"
                    aria-describedby="basic-addon2"
                    placeholder="Enter Email Address"
                    {...register("email", {
                      required: "Email is required",
                      pattern: {
                        value: RegxExpression.email,
                        message: "Invalid email address",
                      },
                    })}
                    // className={classNames("", {
                    //   "is-invalid": errors?.email,
                    //   "is-valid": getValues("email"),
                    // })}
                  />
                  {errors?.email && (
                    <sup className="text-danger">{errors?.email?.message}</sup>
                  )}

                  <p className="expected_format">
                    Expected format: yourname@domain.com
                  </p>
                </Form.Group>

                <Dark_Gray_Btn btnText={"Subscribe"} type="submit" />
              </Form>

              {/* Bottom text */}
              <div className="newsletter_bottom_text">
                <p>
                  By subscribing to our newsletter, you agree to receive
                  information emails concerning offers, services, products, or
                  events from the Group in accordance with the privacy policy.
                </p>

                <p>
                  You can unsubscribe at any time via your online account or the{" "}
                  <span className="unsubscribe_link">“unsubscribe”</span> link
                  at the bottom of each of our email marketing communications
                </p>
              </div>
            </div>
          </Offcanvas.Body>
        </Offcanvas>
        <SuccessfullyModal
          show={showSuccess}
          onHide={() => setShowsuccess(false)}
          text={"Subscribe successfully"}
        />
      </section>
    </>
  );
}

export default Newsletter_offcanvas;
